export const FLAG_GETTING_SEAT_MAPS = 'FLAG_GETTING_SEAT_MAPS';
export const GET_SEAT_MAPS = 'GET_SEAT_MAPS';
export const CLEAR_SEAT_MAPS = 'CLEAR_SEAT_MAPS';
export const FLAG_SEAT_MAP_ACTIVITY = 'FLAG_SEAT_MAP_ACTIVITY';
export const GET_SEAT_MAP = 'GET_SEAT_MAP';
export const CLEAR_SEAT_MAP = 'CLEAR_SEAT_MAP';
